import TenantVerification from "./TenantVerification";
import { useSessionStorage } from "../../hooks";
import {
  ChangePasswordRequest,
  ChangePinRequest,
  CreatePinRequest,
} from "@interfaces/user.interface";
import {
  changePasswordReq,
  changePin,
  createPin,
  deleteUser,
  // getProfile,
  requestTemporaryPin,
  updateProfile,
  updateProfilePic,
} from "@services/krent.service";
import { useEffect, useMemo, useState } from "react";
import { BaseApiResponse } from "@interfaces/app.interface";
// import { NotificationCard } from "@shared/cards";
// import { NotificationsInterfaceResponse } from "@interfaces/notifications.interface";
// import emptyNotifications from "../../assets/images/notifications.png";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import customFetch from "@services/axio";
import { AgentFormInput } from "./agentFormInput";
import { PersonalFormInput } from "./PersonalFormInput";
import { DashboardLayout } from "@layouts/DashboardLayout";
import { toast, ToastContainer } from "react-toastify";
import { Button, Modal } from "react-bootstrap";

const TAB_MAPPING = {
  notifications: "v-pills-home-tab",
  security: "v-pills-disabled-tab",
  pin: "v-pills-pin-tab",
  preferences: "v-pills-messages-tab",
  kyc: "v-pills-kyc-tab",
  "tenant-verification": "v-pills-tenant-verification-tab",
} as const;

export const Settings = () => {
  // type Bank = {
  //   value: string;
  //   label: string;
  // };

  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useSessionStorage("user", {});
  const [loading, setLoading] = useState<boolean>(false);
  const [passwordMatchError, setPasswordMatchError] = useState<boolean>(false);
  const [pinMatchError, setPinMatchError] = useState<boolean>(false);
  const [agentPreviewUrl, setAgentPreviewUrl] = useState<any>("");
  const [agentFile, setAgentFile] = useState<any>(null);
  const [kyc, setKyc] = useState<any>("");
  const [agentKyc, setAgentKyc] = useState<any>("");
  const [profilePicUrl, setProfilePicUrl] = useState<any>("");
  const [profilePic, setProfilePic] = useState<any>(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [reason, setReason] = useState("");
  const [password, setPassword] = useState("");
  const [deactivating, setDeactivating] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const [showForgotPinModal, setShowForgotPinModal] = useState(false);
  const [forgotPinPassword, setForgotPinPassword] = useState("");
  const [togglePinPassword, setTogglePinPassword] = useState(false);
  const [language, setLanguage] = useState<string>("");
  const [timeZone, setTimeZone] = useState<string>("");
  const [currency, setCurrency] = useState<string>("");
  const handleDeactivate = async () => {
    if (!user.id) return;
    setDeactivating(true);
    try {
      const res = await deleteUser(user.id, reason, password);
      toast.success(res.message || "Account deleted successfully!");

      window.location.href = "/";
      setShowDeactivateModal(false);
    } catch (err) {
      if (
        err &&
        typeof err === "object" &&
        "errors" in err &&
        Array.isArray((err as any).errors) &&
        (err as any).errors[0]?.message
      ) {
        toast.error((err as any).errors[0].message);
      } else {
        toast.error("Failed to delete user:");
      }
    } finally {
      setDeactivating(false);
    }
  };
  const canDeactivate = reason.trim().length > 0 && password.trim().length > 0;
  const handleChange = (e: any) => {
    const value = e.target.files;
    // const name = e.target.name
    const [file] = value;
    setProfilePic(value);
    setProfilePicUrl(URL.createObjectURL(file));
  };

  // const [kycType, setKycType] = useState('');
  const [kycData, setKycData] = useState({
    photo: "",
    documentID: "",
    documentType: "",
    expirationDate: "",
    agentId: "",
    agentIdNumber: "",
    address: "",
    firstname: user?.firstname || user?.name?.split(" ")[0] || "",
    lastname: user?.lastname || user?.name?.split(" ").slice(1).join(" ") || "",
    gender: "",
    dateOfBirth: "",
  });

  // Update kycData when user data is loaded
  useEffect(() => {
    if (user?.firstname || user?.name) {
      setKycData((prev) => ({
        ...prev,
        firstname: user?.firstname || user?.name?.split(" ")[0] || "",
        lastname:
          user?.lastname || user?.name?.split(" ").slice(1).join(" ") || "",
      }));
    }
  }, [user?.firstname, user?.lastname, user?.name]);

  // const [photo,setPhoto]= useState('')
  // const [documentID,setDocumentID] = useState('')
  // const [documentType,setDocumentType] = useState('')
  // const [expiryDate,setExpiryDate] = useState('')

  // const [notifications, setNotifications] = useState<
  //   NotificationsInterfaceResponse[]
  // >([]);

  // const [accountNumber, setAccountNumber] = useState('');
  // const [bankCode, setBankCode] = useState('');
  // const [accountName, setAccountName] = useState('');
  // const [banks, setBanks] = useState<Bank[]>([]);
  // const [filteredBanks, setFilteredBanks] = useState<Bank[]>([]);

  // const [bankLoading, setBankLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const canViewTenantVerification = user?.role === "user";
  const requestedTab = searchParams.get("tab") || "security";
  const activeTab = requestedTab === "tenant-verification" && !canViewTenantVerification ? "security" : requestedTab;

  useEffect(() => {
    if (requestedTab !== "tenant-verification" || canViewTenantVerification) return;
    const nextParams = new URLSearchParams(location.search);
    nextParams.set("tab", "security");
    navigate("/settings?" + nextParams.toString(), { replace: true });
  }, [requestedTab, canViewTenantVerification, location.search, navigate]);

  const isTabActive = (tab: keyof typeof TAB_MAPPING) => activeTab === tab;
  const tabPaneClass = (tab: keyof typeof TAB_MAPPING) =>
    `tab-pane fade${isTabActive(tab) ? " show active" : ""}`;
  const navLinkClass = (tab: keyof typeof TAB_MAPPING) =>
    `nav-link text-start text-dark mb-4 rounded-0 ps-5${isTabActive(tab) ? " active" : ""}`;

  // Memoize the reverse tab mapping
  const reverseTabMapping = useMemo(
    () => ({
      "v-pills-home-tab": "notifications",
      "v-pills-disabled-tab": "security",
      "v-pills-pin-tab": "pin",
      "v-pills-messages-tab": "preferences",
      "v-pills-kyc-tab": "kyc",
      "v-pills-tenant-verification-tab": "tenant-verification",
    }),
    [],
  );

  // Handle tab clicks
  useEffect(() => {
    const handleTabClick = (e: Event) => {
      const target = e.currentTarget as HTMLButtonElement;
      const tabId = target.id as keyof typeof reverseTabMapping;
      const tabParam = reverseTabMapping[tabId];
      if (tabParam) {
        const nextParams = new URLSearchParams(location.search);
        nextParams.set("tab", tabParam);
        navigate(`/settings?${nextParams}`, { replace: true });
      }
    };

    // Use event delegation instead of adding listeners to each button
    const handleClick = (e: Event) => {
      const target = e.target as HTMLElement;
      const button = target.closest(".nav-link") as HTMLButtonElement | null;
      if (button) {
        const event = new Event("click");
        Object.defineProperty(event, "currentTarget", { value: button });
        handleTabClick(event);
      }
    };

    const containers = document.querySelectorAll(".nav-theme-vertical");
    containers.forEach((container) => container.addEventListener("click", handleClick));
    return () => {
      containers.forEach((container) => container.removeEventListener("click", handleClick));
    };
  }, [navigate, reverseTabMapping, location.search]);

  const handlePasswordChange = (e: any) => {
    e.preventDefault();
    setLoading(true);
    const { password, newPassword, conPassword } = e.target;
    if (newPassword.value === conPassword.value) {
      const abortController = new AbortController();
      const payload: ChangePasswordRequest = {
        oldPassword: password.value,
        passwordConfirm: conPassword.value,
        password: newPassword.value,
      };
      changePasswordReq(user?.id, abortController.signal, payload)
        .then((res: BaseApiResponse<{}>) => {
          if (res.success) {
            // ktoast.success("Password changed successfully");
            toast.success("Password changed successfully");
            navigate("/sign-in");
          }
        })
        .catch((e) => {
          // ktoast.error("Sorry an error occurred");
          toast.error(e?.errors[0]?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setPasswordMatchError(true);
    }
  };

  // Create Pin
  const handleCreatePin = (e: any) => {
    e.preventDefault();
    setLoading(true);

    const { newPin, conPin } = e.target;

    if (newPin.value === conPin.value) {
      const abortController = new AbortController();

      const payload: CreatePinRequest = {
        walletId: user.wallet,
        pinConfirm: conPin.value,
        pin: newPin.value,
      };

      createPin(abortController.signal, payload)
        .then((res: BaseApiResponse<{}>) => {
          if (res.success) {
            toast.success("Pin created successfully");
            const updatedUser = { ...user, hasPIN: true };
            setUser(updatedUser);
            sessionStorage.setItem("user", JSON.stringify(updatedUser));

            // Handle special messaging payment flow
            if (
              location.state &&
              (location.state as any).flow === "messaging-payment"
            ) {
              // Navigate to wallet to set up account details
              navigate("/caution-fee", {
                state: {
                  flow: "messaging-payment",
                  from: (location.state as any).from,
                  messagingId: (location.state as any).messagingId,
                },
              });
            } else if (location.state && (location.state as any).from) {
              navigate((location.state as any).from, { replace: true });
            }
          }
        })
        .catch((err) => {
          toast.error(err.errors[0].message || "Sorry an error occurred");
        })
        .finally(() => {
          newPin.value = "";
          conPin.value = "";
          setLoading(false);
        });
    } else {
      setPinMatchError(true);
      setLoading(false);
    }
  };

  // Handle Pin Change
  const handlePinChange = (e: any) => {
    e.preventDefault();
    setLoading(true);
    const { pin, newPin, conPin } = e.target;

    if (newPin.value === conPin.value) {
      const abortController = new AbortController();
      const payload: ChangePinRequest = {
        oldPin: pin.value,
        pinConfirm: conPin.value,
        pin: newPin.value,
      };

      changePin(user?.id, abortController.signal, payload)
        .then((res: BaseApiResponse<{}>) => {
          if (res.success) {
            // ktoast.success("Pin changed successfully");
            toast.success("Pin changed successfully");
            if (location.state && (location.state as any).from) {
              navigate((location.state as any).from, { replace: true });
            }
            // Update user state and session storage
            const updatedUser = { ...user, hasPIN: true };
            setUser(updatedUser);
            sessionStorage.setItem("user", JSON.stringify(updatedUser));

            pin.value = "";
            newPin.value = "";
            conPin.value = "";
          }
        })
        .catch((err) => {
          // ktoast.error(err.errors[0].message);
          toast.error(err.errors[0].message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setPinMatchError(true);
      setLoading(false);
    }
  };

  const handleSubmitPreference = (e: any) => {
    e.preventDefault();
    const abortController = new AbortController();
    if (language || currency || timeZone) {
      updateProfile(
        user?.id,
        {
          language,
          currency,
          timezone: timeZone,
        },
        abortController.signal,
      )
        .then(() => {
          // getProfile(abortController.signal).then((res: any) => {
          // setUser(res.data);
          // });
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false);
          setTimeout(() => {
            navigate("/profile");
          }, 1000);
        });
    }
  };

  const handleKycOnChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const name = e.target.name;
    let value: string | FileList | null = null;

    if (name === "photo" || name === "agentId") {
      if (e.target instanceof HTMLInputElement) {
        value = e.target.files;
        if (value && value.length > 0) {
          const file = value[0];
          if (name === "agentId") {
            setAgentFile(file);
            setAgentPreviewUrl(URL.createObjectURL(file));
          }
        }
      }
    } else {
      value = e.target.value;
    }

    if (value !== null) {
      setKycData({ ...kycData, [name]: value });
    }
  };

  const getPersonalKycStatus = async () => {
    try {
      const resp = await customFetch.get("/users/kyc?type=PERSONAL");
      setKyc(resp?.data?.data);
    } catch (error: any) {
      // ktoast.error(error?.response?.data?.errors[0]?.message);
    }
  };
  const getAgentKycStatus = async () => {
    try {
      const agentResp = await customFetch.get("/users/kyc?type=AGENT_LICENCE");
      setAgentKyc(agentResp?.data?.data);
    } catch (error: any) {
      // ktoast.error(error?.response?.data?.errors[0]?.message);
    }
  };

  const handleAgentKycSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    const { agentId, agentIdNumber, address }: any = kycData;
    const abortController = new AbortController();

    if (profilePic) {
      const formData = new FormData();
      formData.append("photo", profilePic[0]);
      updateProfilePic(user?.id, formData, abortController.signal)
        .then((res: any) => {
          setUser(res.data);
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false);
          setTimeout(() => {
            navigate("/profile");
          }, 1000);
        });
    }

    const formData = new FormData();

    if (profilePic && profilePic[0]) {
      formData.append("photo", profilePic[0]);
    }
    formData.append("type", "AGENT_LICENCE");
    formData.append("documentType", "LICENCE_ID");
    agentIdNumber && formData.append("documentID", agentIdNumber);
    agentId && formData.append("photo", agentId[0]);
    address && formData.append("address", address);

    try {
      const res = await customFetch.post(`/users/kyc`, formData);

      if (res.status === 200) {
        setKycData({ ...kycData, agentId: "", agentIdNumber: "" });
        getAgentKycStatus();
      }

      // ktoast.success("Agent Information Added Successfully");
      toast.success("Agent Information Added Successfully");
      if (location.state && (location.state as any).from) {
        navigate((location.state as any).from, { replace: true });
      }
      setLoading(false);
    } catch (error: any) {
      // // ktoast.error(error?.response?.data?.errors[0]?.message);
      toast.error(error?.response?.data?.errors[0]?.message);

      setLoading(false);
    }
  };

  const handleKycSubmit = async (e: any) => {
    e.preventDefault();

    const { documentID, documentType, expirationDate, address }: any = kycData;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("type", "PERSONAL");
      formData.append("firstname", kycData.firstname || "");
      formData.append("lastname", kycData.lastname || "");
      formData.append("gender", kycData.gender || "");
      formData.append("dob", kycData.dateOfBirth || "");
      if (profilePic) {
        formData.append("photo", profilePic[0]);
      }
      documentID && formData.append("documentID", documentID);
      documentType && formData.append("documentType", documentType);
      expirationDate && formData.append("expirationDate", expirationDate);
      address && formData.append("address", address);
      const kycRes = await customFetch.post(`/users/kyc`, formData);
      if (
        kycRes.status === 200 ||
        kycRes.status === ("success" as any) ||
        kycRes.data.status === ("success" as any)
      ) {
        setKycData({
          photo: "",
          documentID: "",
          documentType: "",
          expirationDate: "",
          agentId: "",
          agentIdNumber: "",
          address: "",
          firstname: "",
          lastname: "",
          gender: "",
          dateOfBirth: "",
        });
        getPersonalKycStatus();
        toast.success("Identification Added Successfully");
        if (location.state && (location.state as any).messagingId) {
          navigate(`/messaging/${(location.state as any).messagingId}`, {
            replace: true,
          });
        } else {
          navigate((location.state as any).from, { replace: true });
        }

        // Optional delay before navigation
        // setTimeout(() => {
        //   navigate("/profile");
        // }, 1000);
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.errors?.[0]?.message || "An error occurred",
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const enableScrolling = () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";

      // M≈ake sure all scrollable containers are enabled
      const scrollContainers = [
        ".tab-content",
        ".tab-pane",
        ".main-content",
        '[data-bs-toggle="tab"]',
        ".settings-container",
      ];

      scrollContainers.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((el) => {
          const element = el as HTMLElement;
          element.style.overflowY = "auto";
          element.style.overflowX = "hidden";
          element.style.touchAction = "pan-y";
          (element.style as any).webkitOverflowScrolling = "touch";
        });
      });
    };

    // Function to handle tab changes
    const handleTabChange = () => {
      // Re-enable scrolling
      enableScrolling();

      // Small delay to ensure the tab content is rendered
      setTimeout(() => {
        const activeTab = document.querySelector(
          ".tab-pane.active",
        ) as HTMLElement;
        if (activeTab) {
          // Scroll to the top of the active tab
          window.scrollTo({ top: 0, behavior: "auto" });
          activeTab.scrollTo({ top: 0, behavior: "auto" });

          // Make sure all interactive elements are focusable
          const interactiveElements = activeTab.querySelectorAll(
            "input, select, textarea, button, [tabindex], a",
          );
          interactiveElements.forEach((el: any) => {
            el.style.pointerEvents = "auto";
            el.style.touchAction = "manipulation";
          });
        }
      }, 50);
    };

    // Initial setup
    enableScrolling();

    // Add event listeners for tab changes
    const tabLinks = document.querySelectorAll('[data-bs-toggle="tab"]');
    tabLinks.forEach((tab) => {
      tab.addEventListener("shown.bs.tab", handleTabChange);
    });

    // Handle direct navigation via URL hash
    const handleHashChange = () => {
      if (window.location.hash) {
        setTimeout(handleTabChange, 50);
      }
    };

    window.addEventListener("hashchange", handleHashChange);

    // Initial scroll to top and enable scrolling
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      handleTabChange();

      // Force re-enable scrolling after a short delay
      setTimeout(enableScrolling, 200);
    }, 100);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      tabLinks.forEach((tab) => {
        tab.removeEventListener("shown.bs.tab", handleTabChange);
      });
      window.removeEventListener("hashchange", handleHashChange);

      // Reset any styles we modified
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [searchParams, location.hash]);

  // Add a one-time effect to handle initial page load
  useEffect(() => {
    // Force a reflow and enable scrolling after everything is mounted
    const timer = setTimeout(() => {
      // Enable scrolling on all containers
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";

      // Force scroll to top
      window.scrollTo(0, 0);

      // If there's a hash in the URL, scroll to that section
      if (window.location.hash) {
        const element = document.querySelector(window.location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "auto" });
        }
      }

      // Make sure all scrollable containers are properly sized
      const resizeContainers = () => {
        const viewportHeight = window.innerHeight;
        const scrollableContainers = document.querySelectorAll(
          ".tab-content, .tab-pane",
        );
        scrollableContainers.forEach((container) => {
          const el = container as HTMLElement;
          el.style.minHeight = `${viewportHeight - 200}px`;
          el.style.overflowY = "auto";
        });
      };

      resizeContainers();
      window.addEventListener("resize", resizeContainers);

      return () => window.removeEventListener("resize", resizeContainers);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Fetch user data with cleanup
  useEffect(() => {
    const abortController = new AbortController();

    const fetchData = async () => {
      try {
        await getPersonalKycStatus();
        if (user?.role === "agent") {
          await getAgentKycStatus();
        }

        // const notificationsRes = await getUserNotifications(user?.id, signal);
        // setNotifications(notificationsRes.data);
      } catch (error) {
        const err = error as Error;
        if (err.name !== "AbortError") {
          console.error("Error fetching user data:", error);
        }
      }
    };

    fetchData();

    return () => {
      abortController.abort();
    };
  }, [user]);

  // if (bankLoading) {
  //   return <h4>Loading...</h4>;
  // }
  const handleRequestTemporaryPin = async () => {
    try {
      setLoading(true);

      const res = await requestTemporaryPin({
        email: user.email,
        password: forgotPinPassword,
      });
      if ((res as any).errors) {
        toast.error(
          (res as any).errors[0].message || "Failed to request temporary PIN",
        );
      } else if ((res as any).success) {
        toast.success(
          (res as any)?.message || "Temporary PIN sent to your email",
        );
        setShowForgotPinModal(false);
        setForgotPinPassword("");
      }
    } catch (err: any) {
      toast.error(
        err?.response?.data?.errors?.[0]?.message ||
          err?.message ||
          "Failed to request temporary PIN",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout title="Settings" subtitle=" Manage your account on Krent ">
      <ToastContainer limit={1} />

      <div className="row">
        <div className="col-12">
          <div
            className="card rounded-4 d-flex"
            style={{ backgroundColor: "#FAFAFA" }}
          >
            <div className="card-body" style={{ paddingLeft: ".8rem" }}>
              <div className="row">
                <div className="col-12  d-md-none py-5 ps-0 pe-5 border-end">
                  <div className="d-flex align-items-start">
                    <div
                      className="nav flex-column nav-pills me-3 nav-theme-vertical"
                      id="v-pills-tab"
                      role="tablist"
                      aria-orientation="vertical"
                    >
                      {/* <button
                        className="nav-link text-start text-dark mb-4 rounded-0 ps-5 active"
                        id="v-pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-home"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-home"
                        aria-selected="true"
                      >
                        Notifications
                      </button> */}
                      <button
                        className={navLinkClass("security")}
                        id="v-pills-disabled-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-disabled"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-disabled"
                        aria-selected={isTabActive("security")}
                      >
                        Login &amp; Security
                      </button>
                      {/* {(user.role === 'landlord' || user.role === 'agent') && ( */}
                      <button
                        className={navLinkClass("pin")}
                        id="v-pills-pin-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-pin"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-pin"
                        aria-selected={isTabActive("pin")}
                      >
                        Transaction Pin
                      </button>
                      {/* )} */}
                      <button
                        className={navLinkClass("preferences")}
                        id="v-pills-messages-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-messages"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-messages"
                        aria-selected={isTabActive("preferences")}
                      >
                        Preferences
                      </button>
                      <button
                        className={navLinkClass("kyc")}
                        id="v-pills-kyc-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-kyc"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-kyc"
                        aria-selected={isTabActive("kyc")}
                      >
                        KYC
                      </button>
                      {canViewTenantVerification && <button className={navLinkClass("tenant-verification")} id="v-pills-tenant-verification-tab"
                        type="button" role="tab" aria-controls="v-pills-tenant-verification" aria-selected={isTabActive("tenant-verification")}>
                        Tenant Verification
                      </button>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-3 d-none d-md-inline-block py-5 ps-0 pe-5 border-end">
                  <div className="d-flex align-items-start">
                    <div
                      className="nav flex-column nav-pills me-3 nav-theme-vertical"
                      id="v-pills-tab"
                      role="tablist"
                      aria-orientation="vertical"
                    >
                      {/* <button
                        className="nav-link text-start text-dark mb-4 rounded-0 ps-5 active"
                        id="v-pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-home"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-home"
                        aria-selected="true"
                      >
                        Notifications
                      </button> */}
                      <button
                        className={navLinkClass("security")}
                        id="v-pills-disabled-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-disabled"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-disabled"
                        aria-selected={isTabActive("security")}
                      >
                        Login &amp; Security
                      </button>
                      <button
                        className={navLinkClass("pin")}
                        id="v-pills-pin-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-pin"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-pin"
                        aria-selected={isTabActive("pin")}
                      >
                        Transaction Pin
                      </button>
                      {/* )} */}
                      <button
                        className={navLinkClass("preferences")}
                        id="v-pills-messages-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-messages"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-messages"
                        aria-selected={isTabActive("preferences")}
                      >
                        Preferences
                      </button>
                      <button
                        className={navLinkClass("kyc")}
                        id="v-pills-kyc-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-kyc"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-kyc"
                        aria-selected={isTabActive("kyc")}
                      >
                        {/* Privacy &amp; Sharing */}
                        KYC
                      </button>
                      {canViewTenantVerification && <button className={navLinkClass("tenant-verification")} id="v-pills-tenant-verification-tab"
                        type="button" role="tab" aria-controls="v-pills-tenant-verification" aria-selected={isTabActive("tenant-verification")}>
                        Tenant Verification
                      </button>}
                    </div>
                  </div>
                </div>
                {/* Content Display */}
                <div
                  className="col-12 col-md-9"
                  style={{
                    minHeight: "0",
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100vh - 200px)",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="tab-content flex-grow-1"
                    id="v-pills-tabContent"
                    style={{
                      overflowY: "auto",
                      scrollBehavior: "smooth",
                      WebkitOverflowScrolling: "touch",
                      msOverflowStyle: "none",
                      scrollbarWidth: "none",
                    }}
                  >
                    {/* Notifications Tab - Commented out */}
                    {/* <div
                      className="tab-pane fade show active"
                      id="v-pills-home"
                      role="tabpanel"
                      aria-labelledby="v-pills-home-tab"
                      tabIndex={0}
                      style={{ minHeight: "0" }}
                    >
                      <div
                        className="card-body border-0-last overflow-auto scrollbar-custom"
                        style={{
                          maxHeight: "500px",
                          overflowY: "auto",
                          overflowX: "hidden",
                          padding: "1rem",
                        }}
                      >
                        {notifications.length > 0 ? (
                          notifications.map((notification) => (
                            <NotificationCard
                              key={notification.id}
                              {...notification}
                            />
                          ))
                        ) : (
                          <div className="col text-center p-3">
                            <p className="fs-18 fw-bolder">
                              No notifications yet
                            </p>
                            <img
                              className="py-1"
                              src={emptyNotifications}
                              alt="No Notifications"
                              width={150}
                            />
                            <p className="fs-14 text-secondary text-break">
                              {" "}
                              Any notification you receive would show up here.
                              You don't have any requests right now
                            </p>
                          </div>
                        )}
                      </div>
                    </div> */}
                    {canViewTenantVerification && <div className={tabPaneClass("tenant-verification")} id="v-pills-tenant-verification" role="tabpanel" aria-labelledby="v-pills-tenant-verification-tab" tabIndex={0}>
                      {isTabActive("tenant-verification") && <TenantVerification />}
                    </div>}
                    {/* Login & Security Tab */}
                    <div
                      className={tabPaneClass("security")}
                      id="v-pills-disabled"
                      role="tabpanel"
                      aria-labelledby="v-pills-disabled-tab"
                      tabIndex={0}
                    >
                      <div className="container-fluid">
                        <p className="fw-bold fs-20 mb-5">
                          Login &amp; Security
                        </p>
                        <form className="mb-5" onSubmit={handlePasswordChange}>
                          <div className="row">
                            <div className="mb-4 col-md-6 col-12">
                              <label className="form-label fs-14 fw-600">
                                Old Password
                              </label>
                              <input
                                placeholder="Enter old password"
                                name="password"
                                type="password"
                                className="form-control rounded-pill py-3 px-4 fs-14"
                                required
                              />
                            </div>
                            <div className="mb-4 col-md-6 col-12">
                              <label className="form-label fs-14 fw-600">
                                New Password
                              </label>
                              <input
                                placeholder="Enter new password"
                                name="newPassword"
                                type="password"
                                className="form-control rounded-pill py-3 px-4 fs-14"
                                required
                                onFocus={() => setPasswordMatchError(false)}
                              />
                              {passwordMatchError && (
                                <div
                                  id="emailHelp"
                                  className="form-text text-danger"
                                >
                                  Passwords do not match
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row mb-4">
                            <div className="mb-4 col-md-6 col-12">
                              <label className="form-label fs-14 fw-600">
                                Confirm Password
                              </label>
                              <input
                                placeholder="Confirm your new password"
                                name="conPassword"
                                type="password"
                                className="form-control rounded-pill py-3 px-4 fs-14"
                                required
                              />
                              {passwordMatchError && (
                                <div
                                  id="emailHelp"
                                  className="form-text text-danger"
                                >
                                  Passwords do not match
                                </div>
                              )}
                            </div>
                          </div>

                          <button
                            type="submit"
                            className="btn btn-outline-dark rounded-pill py-3 px-5 fw-bold fs-14"
                            disabled={loading}
                          >
                            {loading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "Save "
                            )}
                          </button>
                        </form>

                        <p className="fw-bolder fs-14 mb-2 mt-5">
                          Deactivate Account
                        </p>
                        <p className="text-secondary fs-12">
                          Remove your account from Krent permanently{" "}
                          <span
                            role="button"
                            className="text-underline text-danger fw-bold"
                            onClick={() => setShowDeactivateModal(true)}
                          >
                            Deactivate
                          </span>
                        </p>
                      </div>
                    </div>
                    {/* Transaction Pin Tab */}
                    <div
                      className={tabPaneClass("pin")}
                      id="v-pills-pin"
                      role="tabpanel"
                      aria-labelledby="v-pills-pin-tab"
                      tabIndex={0}
                    >
                      {user.hasPIN ? (
                        <div className="container-fluid">
                          <p className="fw-bold fs-20 mb-5">
                            Reset Transaction Pin
                          </p>
                          <form className="mb-5" onSubmit={handlePinChange}>
                            <div className="row">
                              <div className="mb-4 col-md-6 col-12">
                                <label className="form-label fs-14 fw-600">
                                  Old Pin
                                </label>
                                <input
                                  placeholder="Enter old pin"
                                  name="pin"
                                  type="password"
                                  maxLength={4}
                                  className="form-control rounded-pill py-3 px-4 fs-14"
                                  required
                                />
                              </div>
                              <div className="mb-4 col-md-6 col-12">
                                <label className="form-label fs-14 fw-600">
                                  New Pin
                                </label>
                                <input
                                  placeholder="Enter new pin"
                                  name="newPin"
                                  type="password"
                                  maxLength={4}
                                  className="form-control rounded-pill py-3 px-4 fs-14"
                                  required
                                  onFocus={() => setPinMatchError(false)}
                                />
                                {passwordMatchError && (
                                  <div
                                    id="emailHelp"
                                    className="form-text text-danger"
                                  >
                                    Pin do not match
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row mb-4">
                              <div className="mb-4 col-md-6 col-12">
                                <label className="form-label fs-14 fw-600">
                                  Confirm Pin
                                </label>
                                <input
                                  placeholder="Confirm your new pin"
                                  name="conPin"
                                  type="password"
                                  maxLength={4}
                                  className="form-control rounded-pill py-3 px-4 fs-14"
                                  required
                                />
                                {pinMatchError && (
                                  <div
                                    id="emailHelp"
                                    className="form-text text-danger"
                                  >
                                    Pin do not match
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="d-grid gap-1">
                              <button
                                type="submit"
                                className="btn btn-outline-dark rounded-pill py-3 px-5 fw-bold fs-14 w-max"
                                disabled={loading}
                              >
                                {loading ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  "Save "
                                )}
                              </button>
                              <button
                                type="button"
                                className="btn btn-link   text-start"
                                onClick={() => setShowForgotPinModal(true)}
                              >
                                Forgot pin?
                              </button>
                            </div>
                          </form>
                          <Modal
                            show={showForgotPinModal}
                            onHide={() => {
                              setShowForgotPinModal(false);
                              setForgotPinPassword("");
                              setTogglePinPassword(false);
                            }}
                            centered
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Request Temporary PIN</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                              <p className="mb-3">
                                Enter your account password to request a
                                temporary transaction PIN.
                              </p>

                              <div className="input-group">
                                <input
                                  type={togglePinPassword ? "text" : "password"}
                                  className="form-control form-control-0 py-3 "
                                  id="password"
                                  placeholder="Enter password"
                                  value={forgotPinPassword}
                                  onChange={(e) =>
                                    setForgotPinPassword(e.target.value)
                                  }
                                  required
                                  style={{ borderRight: "none" }}
                                />

                                <span className="input-group-text input-group-text-0 ">
                                  {togglePinPassword ? (
                                    <i
                                      className="iconly-Show icli fs-4"
                                      onClick={() =>
                                        setTogglePinPassword(!togglePinPassword)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        color: "#05569f",
                                      }}
                                    ></i>
                                  ) : (
                                    <i
                                      className="iconly-Hide icli fs-4"
                                      onClick={() =>
                                        setTogglePinPassword(!togglePinPassword)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        color: "#05569f",
                                      }}
                                    ></i>
                                  )}
                                </span>
                              </div>
                            </Modal.Body>

                            <Modal.Footer>
                              <Button
                                variant="secondary"
                                onClick={() => {
                                  setShowForgotPinModal(false);
                                  setForgotPinPassword("");
                                  setTogglePinPassword(false);
                                }}
                              >
                                Cancel
                              </Button>

                              <Button
                                variant="primary"
                                disabled={loading || !forgotPinPassword}
                                onClick={handleRequestTemporaryPin}
                              >
                                {loading ? "Processing..." : "Request PIN"}
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </div>
                      ) : (
                        <div className="container-fluid">
                          <p className="fw-bold fs-20 mb-5">
                            Create Transaction Pin
                          </p>
                          <form className="mb-5" onSubmit={handleCreatePin}>
                            <div className="row">
                              {/* <div className='mb-4 col-md-6 col-12'>
                                <label className='form-label fs-14 fw-600'>
                                  Old Pin
                                </label>
                                <input
                                  placeholder='Enter old pin'
                                  name='pin'
                                  type='password'
                                  className='form-control rounded-pill py-3 px-4 fs-14'
                                  required
                                />
                              </div> */}
                              <div className="mb-4 col-md-6 col-12">
                                <label className="form-label fs-14 fw-600">
                                  Pin
                                </label>
                                <input
                                  placeholder="Enter new pin"
                                  name="newPin"
                                  type="password"
                                  maxLength={4}
                                  className="form-control rounded-pill py-3 px-4 fs-14"
                                  required
                                  onFocus={() => setPinMatchError(false)}
                                />
                                {passwordMatchError && (
                                  <div
                                    id="emailHelp"
                                    className="form-text text-danger"
                                  >
                                    Pin do not match
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row mb-4">
                              <div className="mb-4 col-md-6 col-12">
                                <label className="form-label fs-14 fw-600">
                                  Confirm Pin
                                </label>
                                <input
                                  placeholder="Confirm your new pin"
                                  name="conPin"
                                  type="password"
                                  maxLength={4}
                                  className="form-control rounded-pill py-3 px-4 fs-14"
                                  required
                                />
                                {pinMatchError && (
                                  <div
                                    id="emailHelp"
                                    className="form-text text-danger"
                                  >
                                    Pin do not match
                                  </div>
                                )}
                              </div>
                            </div>

                            <button
                              type="submit"
                              className="btn btn-outline-dark rounded-pill py-3 px-5 fw-bold fs-14"
                              disabled={loading}
                            >
                              {loading ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                "Save "
                              )}
                            </button>
                          </form>
                        </div>
                      )}
                    </div>
                    {/* Preference Tab */}
                    <div
                      className={tabPaneClass("preferences")}
                      id="v-pills-messages"
                      role="tabpanel"
                      aria-labelledby="v-pills-messages-tab"
                      tabIndex={0}
                    >
                      <div className="container-fluid">
                        <p className="fw-bold fs-20 mb-5">Preferences</p>
                        <form onSubmit={handleSubmitPreference}>
                          <div className="row mb-4">
                            <div className="mb-4 col-md-6 col-12">
                              <label
                                htmlFor="language"
                                className="form-label fs-14 fw-600"
                              >
                                Language
                              </label>
                              <select
                                className="form-select rounded-pill py-2 px-4"
                                id="language"
                                aria-describedby="emailHelp"
                                value={language}
                                onChange={(e) => setLanguage(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="english">English</option>
                                <option value="french">French</option>
                              </select>
                            </div>
                            <div className="mb-4 col-6">
                              <label
                                htmlFor="exampleInputEmail1"
                                className="form-label fs-14 fw-600"
                              >
                                Currency
                              </label>
                              <select
                                className="form-select rounded-pill py-2 px-4"
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                                value={currency}
                                onChange={(e) => setCurrency(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="NGN">Naira - NGN</option>
                                <option value="USD">Dollar - USD</option>
                              </select>
                            </div>
                          </div>

                          <div className="row mb-4">
                            <div className="mb-4 col-md-6 col-12">
                              <label
                                htmlFor="exampleInputEmail1"
                                className="form-label fs-14 fw-600"
                              >
                                Timezone
                              </label>
                              <select
                                className="form-select rounded-pill py-2 px-4"
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                                value={timeZone}
                                onChange={(e) => {
                                  setTimeZone(e.target.value);
                                }}
                              >
                                <option value="">Select</option>
                                <option value="GMT">GMT +1 Lagos</option>
                                <option value="UTC">UTC -05:00 New York</option>
                              </select>
                            </div>
                          </div>

                          <button
                            type="submit"
                            className="btn btn-outline-dark rounded-pill py-3 px-5 fw-bold fs-14"
                          >
                            Save Preferences
                          </button>
                        </form>
                      </div>
                    </div>
                    {/* KYC Tab */}
                    <div
                      className={tabPaneClass("kyc")}
                      id="v-pills-kyc"
                      role="tabpanel"
                      aria-labelledby="v-pills-kyc-tab"
                      tabIndex={0}
                      style={{ minHeight: "0" }}
                    >
                      <p className="fw-bold fs-20 mb-5">
                        Know Your Customer (KYC)
                      </p>

                      <form onSubmit={(e) => e.preventDefault()}>
                        <div className="row">
                          {kyc?.status === "APPROVED" ? (
                            <h5 className="mb-3 text-success">
                              Your{" "}
                              {user.role === "agent" && <span>personal</span>}{" "}
                              Kyc has been approved!
                            </h5>
                          ) : kyc?.status === "PENDING" ? (
                            <p className="mb-3 text-primary fs-20 ">
                              Your{" "}
                              {user.role === "agent" && <span>personal</span>}{" "}
                              KYC submission has been successfully received and
                              is currently undergoing review by one of our legal
                              team members.
                            </p>
                          ) : kyc.status === "REJECTED" ? (
                            <div>
                              <h5>
                                Your{" "}
                                {user.role === "agent" && <span>personal</span>}{" "}
                                KYC has been rejected for the following
                                reason:{" "}
                              </h5>
                              <p className="text-danger mt-3 fs-20">
                                {kyc.rejectionReason}
                              </p>
                              <p className="mb-2">
                                Kindly reupload your Information
                              </p>
                              <PersonalFormInput
                                kycData={kycData}
                                handleKycOnChange={handleKycOnChange}
                                loading={loading}
                                handleKycSubmit={handleKycSubmit}
                                kyc={kyc}
                                profilePicUrl={profilePicUrl}
                                user={user}
                                handleChange={handleChange}
                              />
                            </div>
                          ) : (
                            <PersonalFormInput
                              kycData={kycData}
                              handleKycOnChange={handleKycOnChange}
                              loading={loading}
                              handleKycSubmit={handleKycSubmit}
                              kyc={kyc}
                              profilePicUrl={profilePicUrl}
                              user={user}
                              handleChange={handleChange}
                            />
                          )}
                          {/* Agent ID */}
                          {agentKyc.status === "PENDING" &&
                            (user.role === "agent" ||
                              user.role === "landlord") && (
                              <h4 className="my-3">Agent KYC</h4>
                            )}
                          {agentKyc.status === "PENDING" &&
                          (user.role === "agent" ||
                            user.role === "landlord") ? (
                            <div className="row col-12 md-col-8">
                              <p className="mb-3 text-primary fs-20">
                                Your agent KYC submission has been successfully
                                received and is currently undergoing review by
                                one of our legal team members.
                              </p>
                            </div>
                          ) : agentKyc.status === "APPROVED" &&
                            (user.role === "agent" ||
                              user.role === "landlord") ? (
                            <p className="mb-3 text-success fs-20">
                              Your{" "}
                              {(user.role === "agent" ||
                                user.role === "landlord") && (
                                <span>agent</span>
                              )}{" "}
                              KYC has been approved!
                            </p>
                          ) : agentKyc.status === "REJECTED" &&
                            (user.role === "agent" ||
                              user.role === "landlord") ? (
                            <div>
                              <h5>
                                Your agent KYC has been rejected for the
                                following reason:{" "}
                              </h5>
                              <p className="text-danger mt-3 fs-20">
                                {agentKyc.rejectionReason}
                              </p>

                              <p className="mb-2">
                                Kindly reupload your Information
                              </p>
                              <AgentFormInput
                                user={user}
                                handleAgentKycSubmit={handleAgentKycSubmit}
                                kycData={kycData}
                                loading={loading}
                                handleKycOnChange={handleKycOnChange}
                                previewUrl={agentPreviewUrl}
                                file={agentFile}
                              />
                            </div>
                          ) : (
                            // newFunction(user, handleKycOnChange, kycData, loading, handleAgentKycSubmit)
                            <div>
                              <AgentFormInput
                                user={user}
                                handleAgentKycSubmit={handleAgentKycSubmit}
                                kycData={kycData}
                                loading={loading}
                                handleKycOnChange={handleKycOnChange}
                                previewUrl={agentPreviewUrl}
                                file={agentFile}
                              />
                            </div>
                          )}
                        </div>
                      </form>
                      {/* )} */}
                      {/* Agent cert Kyc */}
                      {/* {kycType === "AGENT_LICENCE" && ( */}
                      {/* <form onSubmit={handleKycSubmit}>
                        <div className='row'>
                          <div className='row'>
                            <div className='col-md-6 col-12 mb-4'>
                              <label className='fw-bolder form-label text-capitalize'>
                                Identification Type
                              </label>
                              <select
                                className='form-select rounded-pill py-3 px-4 fs-14 mb-3'
                                value={kycData.documentType}
                                onChange={handleKycOnChange}
                                required
                                name='documentType'
                              >
                                <option value=''>Select</option>
                                <option value='LICENCE_ID'>
                                  Agent License
                                </option>
                                <option value='CAC'>CAC</option>
                              </select>
                            </div>
                            <div className='col-md-6 col-12 mb-4'>
                              <label className='fw-bolder form-label text-capitalize'>
                                Upload ID
                              </label>
                              <div className='input-group mb-3'>
                                <input
                                  type='file'
                                  className='form-control border-end-0 border-rounded-5 py-3 px-4 rounded-pill-start'
                                  placeholder='No file selected'
                                  id='inputGroupFile02'
                                  name='photo'
                                  onChange={handleKycOnChange}
                                />
                                <label
                                  className='input-group-text rounded-pill-end bg-transparent text-link text-decoration-none border-start-0 pe-4'
                                  htmlFor='inputGroupFile02'
                                >
                                  Upload
                                </label>
                              </div>
                            </div>
                            <div className='col-md-6 col-12 mb-4'>
                              <label className='fw-bolder form-label text-capitalize'>
                                ID Number
                              </label>
                              <input
                                type='text'
                                className='form-control rounded-pill py-3 px-4 fs-14 mb-3'
                                value={kycData.documentID}
                                onChange={handleKycOnChange}
                                required
                                name='documentID'
                                placeholder='Input License ID'
                              />
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-md-6 col-12 mb-4'>
                              <label className='fw-bolder form-label text-capitalize'>
                                Upload Certificate
                              </label>
                              <div className='input-group mb-3'>
                                <input
                                  type='file'
                                  className='form-control border-end-0 border-rounded-5 py-3 px-4 rounded-pill-start'
                                  placeholder='No file selected'
                                  id='inputGroupFile02'
                                  name='photo'
                                  onChange={handleKycOnChange}
                                />
                                <label
                                  className='input-group-text rounded-pill-end bg-transparent text-link text-decoration-none border-start-0 pe-4'
                                  htmlFor='inputGroupFile02'
                                >
                                  Upload
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            <div>
                              <button
                                type='submit'
                                className='btn btn-primary rounded-pill py-3 px-5 fw-bold fs-14'
                                disabled={loading}
                              >
                                {loading ? (
                                  <span
                                    className='spinner-border spinner-border-sm'
                                    role='status'
                                    aria-hidden='true'
                                  ></span>
                                ) : (
                                  'Save'
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form> */}
                      {/* )} */}
                    </div>
                    {/* end kyc */}
                  </div>
                </div>
                {/* end of content display */}
              </div>
              {/* end of right section */}
            </div>
          </div>
          {/* end of card */}
        </div>
      </div>
      <Modal
        show={showDeactivateModal}
        onHide={() => setShowDeactivateModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-danger fw-bold">
            Deactivate Account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">
            Are you sure you want to permanently deactivate your account? This
            action <strong>cannot be undone.</strong>
          </p>

          <div className="mb-3">
            <label className="form-label fw-bold fs-14">Reason</label>
            <textarea
              className="form-control rounded-3"
              rows={3}
              placeholder="Tell us why you’re leaving..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>

          <div className="form-group col mb-3">
            <label className=" fw-600 fs-14 m-1" htmlFor="password">
              Password
            </label>
            <div className="input-group">
              <span
                className="input-group-text input-group-text-0 "
                id="basic-addon1"
              >
                <i className={`iconly-Lock icli fs-4`}></i>
              </span>

              <input
                type={togglePassword ? "text" : "password"}
                className="form-control form-control-0 ps-3 py-3 border-start-0"
                id="password"
                aria-describedby="emailHelp"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ borderRight: "none" }}
              />

              <span className="input-group-text input-group-text-0 ">
                {togglePassword ? (
                  <i
                    className="iconly-Show icli fs-4"
                    onClick={() => setTogglePassword(!togglePassword)}
                    style={{ cursor: "pointer", color: "#05569f" }}
                  ></i>
                ) : (
                  <i
                    className="iconly-Hide icli fs-4"
                    onClick={() => setTogglePassword(!togglePassword)}
                    style={{ cursor: "pointer", color: "#05569f" }}
                  ></i>
                )}
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeactivateModal(false)}
            className="rounded-pill px-4"
            disabled={deactivating}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={!canDeactivate || deactivating}
            onClick={handleDeactivate}
            className="rounded-pill px-4 fw-bold bg-red"
          >
            {deactivating ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              "Deactivate"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </DashboardLayout>
  );
};
